export function overrideModalBlanketStyles(testId: string): void {
  const target = document.querySelector<HTMLElement>(`[data-testid=${testId}--blanket]`);
  if (target) {
    target.style.background = 'rgba(255, 255, 255, 0.6)';
  }

  // ensure the color is applied before the next paint
  requestAnimationFrame(() => {});
}
